<template>
    <svg width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M34 127H167.5" stroke="black" stroke-width="2" stroke-linecap="round"/>
        <path d="M58.3815 54.5431C60.5565 55.412 62.5501 59.6117 63.2751 61.603H80.0715C80.9777 59.4307 83.1163 54.8689 84.4213 54C86.0525 54 95.0094 58.8876 98.8155 74.6366C106.428 72.6454 127.596 68.3023 139.775 79.1637C149.086 87.4667 154.873 97.5344 152.446 117.539C151.721 123.513 147.008 136.981 133.959 143.063C120.91 149.146 110.579 146.572 105.685 144.693C98.6166 141.977 92.2006 136.329 88.2858 126.771C79.0424 126.952 59.1417 127.206 53.4857 126.771C48.5921 120.797 44.0826 103.175 45.1612 87.5516C46.5047 68.0916 55.1192 58.3446 58.3815 54.5431Z"
              fill="white"/>
        <path d="M88.2858 126.771C79.0424 126.952 59.1417 127.206 53.4857 126.771C48.5921 120.797 44.0826 103.175 45.1612 87.5516C46.5047 68.0916 55.1192 58.3446 58.3815 54.5431C60.5565 55.412 62.5501 59.6117 63.2751 61.603H80.0715C80.9777 59.4307 83.1163 54.8689 84.4213 54C86.0525 54 95.0094 58.8876 98.8155 74.6366M88.2858 126.771C92.2006 136.329 98.6166 141.977 105.685 144.693C110.579 146.572 120.91 149.146 133.959 143.063C147.008 136.981 151.721 123.513 152.446 117.539C154.873 97.5344 149.086 87.4667 139.775 79.1637C127.596 68.3023 106.428 72.6454 98.8155 74.6366M88.2858 126.771C87.5608 124.056 86.3284 116.562 87.1984 108.307C88.0683 102.659 91.5482 101.971 93.1794 102.333C94.4481 102.333 96.9855 103.202 96.9855 106.678C96.9855 111.022 98.0729 122.427 101.335 127.314C104.598 132.202 110.035 136.546 121.997 136.546C128.522 136.003 131.784 131.116 132.872 127.314M98.8155 74.6366C100.12 79.4156 100.084 87.8513 99.903 91.4718"
              stroke="black" stroke-width="2" stroke-linecap="round"/>
        <path d="M132.499 95.937C118.544 85.796 118.689 77.0145 120.506 73.8913L121.05 72.7891C126.355 73.4601 133.845 73.7705 141.71 82.0106C148.499 89.1224 150.512 94.9331 151.591 99.4656C147.23 99.4656 139.405 100.956 132.499 95.937Z"
              fill="#2F65FA"/>
        <path d="M70.9873 67.4219C66.6347 67.4219 63.6971 64.0085 62.9414 62.3891C66.1152 61.9475 73.1338 61.5054 80.3882 62.3887C79.9348 65.0387 76.4281 67.4219 70.9873 67.4219Z"
              fill="#3963F7"/>
        <rect x="66.4375" y="61.2441" width="1.75495" height="3.50989" rx="0.877473" fill="black"/>
        <rect x="70.6602" y="61.3809" width="1.7581" height="4.69722" rx="0.879051" fill="black"/>
        <rect x="75.2148" y="61.2441" width="1.75495" height="3.50989" rx="0.877473" fill="black"/>
        <path d="M69.8332 76.1629C69.8332 79.8331 66.3061 83.0601 61.6197 83.0601C56.9334 83.0601 53.4062 79.8331 53.4062 76.1629C53.4062 72.4927 56.9334 69.2656 61.6197 69.2656C66.3061 69.2656 69.8332 72.4927 69.8332 76.1629Z"
              fill="white" stroke="black" stroke-width="2"/>
        <path d="M90.0129 76.1629C90.0129 79.8331 86.4858 83.0601 81.7994 83.0601C77.1131 83.0601 73.5859 79.8331 73.5859 76.1629C73.5859 72.4927 77.1131 69.2656 81.7994 69.2656C86.4858 69.2656 90.0129 72.4927 90.0129 76.1629Z"
              fill="white" stroke="black" stroke-width="2"/>
        <path d="M69.0898 85.815C69.2361 86.4 69.7041 87.5699 70.4061 87.5699C71.5462 87.5699 72.161 87.1312 72.161 86.2537M72.161 86.2537C72.161 85.9027 72.161 85.23 72.161 84.9375V86.2537ZM72.161 86.2537C72.161 86.6924 72.4242 87.5699 73.4772 87.5699C74.5302 87.5699 74.7934 86.6924 74.7934 86.2537"
              stroke="black"/>
        <ellipse cx="72.1768" cy="83.6228" rx="1.75495" ry="1.31621" fill="black"/>
        <path d="M97.8556 119.867L88.3047 123.161L88.9634 127.113L98.8436 123.49L97.8556 119.867Z" fill="#2F65FA"/>
        <path d="M93.9023 135.347L101.807 129.09L104.441 131.725L96.5371 138.311L93.9023 135.347Z" fill="#2F65FA"/>
        <path d="M106.09 144.238L110.701 135.346L114.323 136.334L110.042 145.555L106.09 144.238Z" fill="#2F65FA"/>
        <path d="M53.2381 126.675C51.8961 124.887 49.8568 120.395 47.8438 113.349L58.1515 104.326C58.1515 109.243 60.3895 123.546 59.9425 125.334C59.4956 127.122 58.1515 128.016 56.3668 128.462C54.9391 128.82 53.6861 127.42 53.2381 126.675Z"
              fill="white"/>
        <path d="M79.1619 125.334C79.6039 120.417 79.4599 109.69 79.1619 104.326C82.5905 103.544 89.1122 102.448 87.7701 104.326C86.0925 106.675 86.428 110.701 86.0925 115.063C85.8241 118.552 86.6517 122.78 87.0991 124.457C86.0264 129.821 83.7805 129.505 82.2907 129.356C80.9498 129.058 79.1619 128.462 79.1619 125.334Z"
              fill="white"/>
        <path d="M47.8438 113.386C49.8568 120.431 51.8961 124.924 53.2381 126.711C53.6861 127.456 54.9391 128.857 56.3668 128.499C58.1515 128.052 59.4956 127.158 59.9425 125.371C60.3895 123.583 58.1515 109.28 58.1515 104.363M79.1619 104.363C79.4599 109.727 79.6039 120.454 79.1619 125.371C79.1619 128.499 80.9498 129.095 82.2907 129.393C83.6122 129.525 86.3168 128.72 87.6599 124.793"
              stroke="black" stroke-width="2" stroke-linecap="round"/>
        <rect x="52.5391" y="121.102" width="1.34206" height="6.03928" rx="0.671031" fill="black"/>
        <rect x="84.5195" y="122.242" width="1.34206" height="6.25748" rx="0.671031" fill="black"/>
        <rect x="55.918" y="122.242" width="1.34206" height="6.25748" rx="0.671031" fill="black"/>
        <rect x="81.8398" y="123.137" width="1.34206" height="6.25748" rx="0.671031" fill="black"/>
        <circle class="eye" cx="57" cy="72.5" r="2" fill="black"/>
        <circle class="eye" cx="77" cy="72.5" r="2" fill="black"/>
        <path opacity="0.6" class="flyb" fill-rule="evenodd" clip-rule="evenodd"
              d="M41.5471 34.6516C41.5471 34.6516 43.0429 32.0739 45.6059 30.9438C48.1689 29.8137 51.2641 29.6632 51.5674 30.1962C51.8707 30.7291 51.8492 32.4089 51.2106 33.0133C50.5719 33.6177 49.4581 34.6167 49.2824 35.703C49.1066 36.7892 49.1608 37.4184 48.448 37.3862C47.7352 37.354 46.8973 36.7827 46.6818 37.1625C46.4663 37.5423 47.2671 37.9788 47.7851 38.805C48.3031 39.6311 47.9969 39.914 47.3281 41.3232C46.6594 42.7324 46.3255 43.2958 45.5983 43.5371C44.8711 43.7783 43.5124 43.608 42.7664 42.4628C41.9682 41.2374 40.7666 39.2802 41.5471 34.6516Z"
              fill="#2F65FA"/>
        <path opacity="0.6" class="flya" fill-rule="evenodd" clip-rule="evenodd"
              d="M41.8629 35.0216C41.8629 35.0216 42.231 32.0642 40.8735 29.614C39.516 27.1638 37.1422 25.1718 36.5784 25.4127C36.0145 25.6537 35.0155 27.0043 35.1585 27.8719C35.3015 28.7396 35.5842 30.2088 35.0671 31.1801C34.5501 32.1514 34.1264 32.6197 34.7134 33.0252C35.3005 33.4307 36.3134 33.4826 36.2553 33.9154C36.1971 34.3482 35.2953 34.2114 34.3831 34.5559C33.4709 34.9005 33.5437 35.311 33.2239 36.8377C32.9041 38.3644 32.8292 39.015 33.2624 39.647C33.6955 40.279 34.8805 40.9652 36.1672 40.5044C37.5441 40.0113 39.6848 39.1796 41.8629 35.0216Z"
              fill="#2F65FA"/>
    </svg>
</template>

<style>
@keyframes eyeanim {
    0% {offset-distance: 0%;}
    100% {offset-distance: 100%;}
}

@keyframes flyaanim {
    0% {
        offset-distance: 0%;
        transform: rotate3d(2,-1, -1, -0.2turn);
    }
    25%{
        transform: rotate3d(1, 1, 1, 45deg);
    }
    50%{
        transform: rotate3d(2, -1, -1, -0.2turn);
    }
    75%{
        transform: rotate3d(1, 1, 1, 45deg);
    }
    100% {
        offset-distance: 100%;
        transform: rotate3d(2, -1, -1, -0.2turn);
    }
}
@keyframes flybanim {
    0% {
        offset-distance: 0%;
        transform: rotate3d(1, 1, 1, 25deg);
    }
    25%{
        transform: rotate3d(2, -2, -1, 0.4turn);
    }
    50%{
        transform: rotate3d(1, 1, 1, 25deg);
    }
    75%{
        transform: rotate3d(2, -2, -1, 0.4turn);
    }
    100% {
        offset-distance: 100%;
        transform: rotate3d(1, 1, 1, 25deg);
    }
}

.eye{
    animation: eyeanim 2000ms infinite alternate ease-in-out;
    offset-path: path("M0.5 2.5C1.5 1.5 2.5 1 4.5 1C6 1 7.5 1.5 8.5 2.5");
    offset-rotate: 0deg;
}

.flya{
    animation: flyaanim 2000ms infinite alternate ease-in-out 200ms;
    transform-origin: 21% 17%;
    offset-path: path("M25 50.5C37.5 44.5 63 29 95 29C127 29 152 44 157.5 50.5");
    offset-rotate: 0deg;
}
.flyb{
    animation: flybanim 2000ms infinite alternate ease-in-out 200ms;
    transform-origin: 21.5% 17%;
    offset-path: path("M25 50.5C37.5 44.5 63 29 95 29C127 29 152 44 157.5 50.5");
    offset-rotate: 0deg;
}
</style>
<script setup>
</script>
